import { LOCATION_TYPE, PAYMENT_METHOD } from "@/types/enum/supplierEnum";
import { TEAM_ROLE_CODE_NAME } from "@/types/enum/storeEnum";

const label = {
    confirm: 'bestätigen',
    pwConfirm: '@:input.password @:label.confirm',
    newReminder: 'Neuen Bestellwecker hinzufügen',
    selectPlaceholder: 'Bitte auswählen',
    orderHint: 'Hinweis des Lieferanten',
    selectTitle: 'Auswählen',
    date: '@:input.date',
    time: 'Uhrzeit',
    dateTime: '@:label.date und @:label.time',
    sum: 'Summe',
    orderDetails: 'Rechnungdetails',
    promoCode: 'Gutscheincode',
    orderNumber: 'Bestellnummer',
    octopusId: 'Octopus ID',
    orderMessage: 'Bestellnachricht',
    description: 'Beschreibung',
    sort: 'Sortieren',
    priceRange: 'Preisrange',
    login: 'Bitte einloggen',
    user: 'Benutzer',
    newEmail: 'Neue Email',
    oldPassword: 'Altes @:input.password',
    password: '@:input.password',
    pwForget: '@:input.password vergessen',
    contactData: 'Kontaktdaten',
    name: 'Name',
    list: 'Liste',
    type: 'Typ',
    zip: 'PLZ',
    city: 'Stadt',
    street: 'Adresse',
    streetNumber: 'Hausnummer',
    phone: 'Telefon',
    fax: 'Fax',
    streetName: 'Strassenname',
    postalCode: '@:label.zip',
    deliverer: '@:object.deliverer',
    customerNumber: 'Kundennummer/Absatzstättennummer',
    quickstart: 'Quickstart Code',
    email: '@:input.email',
    firstName: 'Vorname',
    lastName: 'Name',
    dark: 'Dunkel',
    light: 'Hell',
    standard: 'Systemeinstellung',
    amount: 'Menge',
    multipleAmount: 'Menge muss ein vielfaches von {target} sein',
    maxAmount: 'Maximal {target} Artikel',
    standardList: 'Standard Liste',
    language: 'Sprache',
    aiCallLanguage: 'Anrufsprache',
    oldMessages: 'Ältere Nachrichten',
    notification: {
        allow: 'Mitteilungen erlauben'
    },
    permission: {
        order: '@:object.order',
        promotion: '@:object.promotion',
        message: '@:object.message',
        news: 'News',
        reminder: 'Bestellerinnerung',
        productPromotion: 'Produktvorschläge',
        sub: {
            newOrder: 'Neue Bestellungen',
            updateStatus: 'Bestellungsupdate',
            added: 'Neue Promotion',
            ending: 'Promotion am',
            general: 'Allgemein'
        },
        mode: {
            push: 'Push Nachricht',
            email: 'Email Benachrichtigung',
            popup: 'Popup'
        }
    },
    teamRole: {
        [TEAM_ROLE_CODE_NAME.ADMIN]: 'Admin',
        [TEAM_ROLE_CODE_NAME.USER]: 'Teammitglied Pro',
        [TEAM_ROLE_CODE_NAME.DEVICE]: 'Teammitglied Basis',
        [TEAM_ROLE_CODE_NAME.OWNER]: 'Besitzer'
    },
    teamRoleShort: {
        [TEAM_ROLE_CODE_NAME.ADMIN]: 'Admin',
        [TEAM_ROLE_CODE_NAME.USER]: 'Pro',
        [TEAM_ROLE_CODE_NAME.DEVICE]: 'Basis',
        [TEAM_ROLE_CODE_NAME.OWNER]: 'Besitzer'
    },
    support: {
        general: 'Octopus Support',
        gastro: 'Team Customer Service Gastro',
        technical: 'Team Technical Customer Service',
        technicalLead: 'Technical Leader',
        distribution: 'Prokurist, Marketing, Vertrieb',
        service: 'Team Customer Service'
    },
    loading: {
        location: 'Lade @:object.location'
    },
    onAccount: 'Rechnung',
    onAccountOrCash: 'Rechnung oder Bar',
    [PAYMENT_METHOD.ON_ACCOUNT]: '@:label.onAccount',
    [PAYMENT_METHOD.UNSPECIFIED]: 'nicht angegeben',
    [PAYMENT_METHOD.CASH]: '@:label.cash',
    cash: 'Bar',
    [LOCATION_TYPE.BAR]: 'Bar / Kneipe',
    [LOCATION_TYPE.OFFICE]: 'Büro',
    [LOCATION_TYPE.COFFEE_SHOP]: 'Café / Bistro',
    [LOCATION_TYPE.CATERER]: 'Caterer / Kantine / Vereine',
    [LOCATION_TYPE.CLUB]: 'Club / Diskothek',
    [LOCATION_TYPE.EVENT]: 'Event',
    [LOCATION_TYPE.DEALER]: 'Händler',
    [LOCATION_TYPE.TAKE_AWAY]: 'Imbiss / Kiosk / Take-Away',
    canteen: 'Kantine',
    [LOCATION_TYPE.RESTAURANT]: 'Restaurant',
    [LOCATION_TYPE.HOTEL]: 'Hotel',
    [LOCATION_TYPE.SPAETSHOP]: 'Tankstelle / Spätshop', //Ja, ich weiß. War Lorenz Wunsch
    // [LOCATION_TYPE.OTHER]: 'Diverses Unternehmen',
    [LOCATION_TYPE.GETRAENKEHAENDLER]: 'Getränkehändler',
    [LOCATION_TYPE.GETRAENKEABHOLMARKT]: 'Getränkeabholmarkt',
    [LOCATION_TYPE.STAR_GASTRONOMY]: 'Sternegastronomie',
    [LOCATION_TYPE.SYSTEM_GASTRONOMY]: 'Systemgastronomie',
    spaetShop: 'Spätshop',
    impress: 'Impressum',
    termsOfUse: 'Nutzungsbedingungen',
    agreeAGB1: 'Ich stimme der',
    agreeAGB2: 'Datenschutzbestimmung',
    agreeAGB3: 'zu',
    category: 'Kategorie',
    noCategory: 'Ohne Kategorie',
    editTags: 'Eigene Kategorien anlegen',
    selectDeliverer: '@:object.deliverer auswählen',
    threeChars: 'Mindestens drei Zeichen eingeben, um Suchergebnisse zu erhalten',
    offlineMode: 'Offline-Modus',
    disable: 'deaktivieren',
    enable: 'aktivieren',
    at: 'am',
    atTime: 'um',
    and: 'und',
    customerNo: 'Kundennummer',
    current: 'Aktuell',
    tags: 'Filterkategorien',
    ownCategories: 'Eigene Kategorien',
    supplierCategories: 'Lieferanten-Kategorien',
    noFilter: 'Kein Filter',
    quantity: 'Menge',
    quantityBiggerZero: 'Mit Menge',
    or: 'oder',
    delivererType: {
        online: 'Online',
        offline: 'Offline'
    },
    deleted: 'Gelöscht',
    resetAmount: 'Produktmenge nach Bestellung zurücksetzen',
    compatibilityMode: 'Kompatibilitätsmodus',
    timeIssueDelivery: 'Der von Dir angegebene Lieferzeitpunkt liegt in der Vergangenheit. Bitte wähle einen späteren Zeitpunkt.',
    timeIssuePickup: 'Der von Dir angegebene Abholzeitpunkt liegt in der Vergangenheit. Bitte wähle einen späteren Zeitpunkt.',
    wait: 'Bitte warten',
    day: 'Tag',
    month: 'Monat',
    all: 'Alle',
    articleNo: 'Artikel-Nr.',
    targetStock: 'Sollmenge',
    targetStockShort: 'Soll',
    resetProductQuantity: 'Durch aktivieren des Schiebreglers wir die Produktmenge nach erfolgreicher Übertragung deiner Bestellung auf Null zurückgesetzt. Bei nicht-aktivieren bleibt die Produktmenge für die nächste Bearbeitung deiner Liste vorausgefüllt.',
    offlineMode1: 'Der Offline-Modus gibt dir die Möglichkeit deine Liste zu synchronisieren und anschließend auch ohne Internetverbindung zu verwalten.',
    offlineMode2: 'Beim Beenden des Offline-Modus werden alle Änderungen mit dem Server synchronisiert.',
    darkMode: 'Dunkler Modus',
    compatibilityText: {
        activate: 'Aktiviere diesen Modus, wenn du die Produktmengen in deiner Liste in der App bearbeiten möchtest, die Bestellung aber über das Web-Portal tätigst.',
        webPortal: 'Solange dieser Modus aktiviert ist, wird die Listenmenge mit dem Web-Portal synchronisiert und eine Bestellung dieser Liste ist über die App nicht möglich.',
        deactivate: 'Deaktiviere diesen Modus, wenn du über die App bestellen möchtest.'
    },
    newProductSuggestion: 'Neuer Produktvorschlag',
    files: 'Dateien',
    issue: 'Problem',
    place: 'Ort',
    expectation: 'Erwartung',
    steps: 'Schritte',
    availability: 'Verfügbarkeit',
    availableFrom: 'Verfügbar bei',
    deletedLocations: 'Gelöschte Locations',
    reducedListDesign: "Reduziertes Listen-Design",
    reducedListDesignDescription: "Das reduzierte Listen-Design verändert die Ansicht deiner Liste. Produktbilder werden ausgeblendet, dafür werden zusätzliche Buttons zur Bedienung angezeigt.",
    insert: "einfügen",
    camera: "Kamera",
    scanner: "Scanner",
    picture: {
        takePicture: "Foto aufnehmen",
        selectPicture: "Bild auswählen",
        editPicture: "Bild bearbeiten",
        removePicture: "Bild entfernen"
    },
    uncategorized: 'Unkategorisiert',
    orderDataLoading: 'Bestelldaten werden geladen.',
    screenshot: 'Screenshot',
    uploadImage: 'Bild hochladen',
    aiCallbackPhone: 'Telefonnummer für Rückruf Hinterlegen'
}

export default label;
